<template>
    <div class="proCon">
      <img class="banner animated fadeIn" src="../assets/pro/ban.png" alt="" id="d1">
      <div class="link wow fadeInLeft">
        <div class="main">
          <span class="title">{{$t('product.link[0]')}}</span>
          <span>{{$t('product.link[1]')}}</span>
        </div>
      </div>
      <div class="mainCon">
         <div class="left wow fadeInLeft">
           <div class="title">
             <p>{{$t('product.Title')}}</p>
           </div>
           <ul>
<!--             <li v-for="(item,index) in navList" :key="index" @mouseenter="getPro2(item.ID)" @mouseleave="hide">-->
             <li v-for="(item,index) in navList" :key="index" @click="getPro2(item.ID)">
            <span class="aSpan" :style="select===index?colorStyle:''" style="font-family: light2">{{item.CALLED}}</span>
            <i class="iconfont icon-tianjia" ></i>
<!--               <div class="third animated fadeIn">-->
<!--                 <span v-for="(i,idx) in pro2" :key="idx">{{i.CALLED}}</span>-->
<!--               </div>-->
             </li>
           </ul>
         </div>
        <div class="right wow fadeInRight">
       <div class="item" v-for="(item,index) in proList" :key="index" >
         <router-link :to="{path: 'proInfo', query: { id: item.ID }}" target="_blank">
           <img :src="`http://www.pan-am.com.cn/upload/${item.SMALLPIC}`" alt="">
           <p>{{item.PRONAME}}</p>
         </router-link>
       </div>
        </div>
      </div>
      <div class="aBtn wow fadeInUp" @click="showMore">
    <Btn-Component :text="text"></Btn-Component>
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
</template>

<script>
  import footComponent from "./foot"
  import firstComponent from "./first"
  import BtnComponent from "./btn"
  import Scrollbar from 'smooth-scrollbar';
  import {getProductstypeUrl2,getProductsUrl} from '../util/lang'
    export default {
        name: "pro",
      data(){
          return{
            text:'',
            colorStyle:{
              color:'#C9382C'
            },
            select:'',
            page:1,
            proList:[
            ],
            navList:[],
            pro2:[],
            totalPage:'',
            id:'23'
          }
      },
      mounted(){
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        this.text=this.$t('btn')
        this.$nextTick(()=>{
          // this.getPro()
          if(this.$i18n.locale==='en'){
            this.getPro('23')
            this.id='23'
          }else{
            this.id='36'
            this.getPro('36')
          }
          if(this.$route.query.id!==undefined && this.$route.query.select!==undefined){
            this.select=this.$route.query.select
            this.getPro2(this.$route.query.id)
          }else{
            if(this.$i18n.locale==='en'){
              this.getAllPro('23')
            }else{
              this.getAllPro('36')
            }
          }
        })
      },
      components:{footComponent,firstComponent,BtnComponent},
      methods:{
        showMore(){
          if(this.page<=this.totalPage){
            this.$nextTick(()=>{
              const url = `${getProductsUrl( this.$i18n.locale,this.id,6,this.page++)}`
              this.$axios.get(url).then(res => {
                this.proList=this.proList.concat(res.data.proarr)
              })
            })
          }else{
            if( this.$i18n.locale==='en'){
              this.text='End'
            }else{
              this.text='最后一页'
            }
            this.$notify({
              title: '提示',
              message: '已经加载全部了',
              offset: 100
            });
          }
        },
          hide(){
            this.pro2=[]
          },
        getAllPro(id){
          this.page=2
          const url = `${getProductsUrl( this.$i18n.locale,id,6,1)}`
          this.$axios.get(url).then(res => {
            this.proList=res.data.proarr
            this.totalPage=res.data.pagershow.totalPagers
            // console.log(res.data)
          })
        },
        getPro2(id){
          this.id=id
          this.page=2
          this.text=this.$t('btn')

            // const url = `${getProductstypeUrl2( this.$i18n.locale,id)}`
            const url = `${getProductsUrl( this.$i18n.locale,id,6,1)}`
            this.$axios.get(url).then(res => {
              this.proList=res.data.proarr
              this.totalPage=res.data.pagershow.totalPagers
              // console.log(res.data)
            })
        },
        getPro(id){
            const url = `${getProductstypeUrl2( this.$i18n.locale,id)}`
            this.$axios.get(url).then(res => {
              this.navList=res.data
            })
        },
        gotoTop(){
          Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#d1"))
        },
          gotoInfo(id){
            this.$router.push({path:'/proInfo',query:{id:id}})
          }
      }
    }
</script>

<style  scoped>
.proCon{
  width:100%;
}
  .banner{
    width:100%;
    display: block;
  }
  .link{
    width:100%;
    padding: 30px 0;
    border-bottom: 1px solid rgba(250, 250, 250, 1);
  }
  .link .main{
    width:1280px;
    margin: 0 auto;
    text-align: left;
  }
  .link .main span{
    color:#C9382C;
    text-transform: uppercase;
  }
  .link .main .title{
    color:black;
  }
  .mainCon{
    width:1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    padding-bottom: 60px;
  }
  .mainCon .left{
    width:15%;
  }
  .mainCon .left p{
    font-size: 30px;
    font-weight: bold;
    text-transform: uppercase;
    text-align: left;
    position: relative;
    padding-bottom: 10px;
  }
.mainCon .left p::after{
  content: '';
  display: inline-block;
  width:20%;
  height:3px;
  position: absolute;
  bottom:0;
  left:0;
  background-color: #C9382C;
}
.mainCon .left ul{
  width:100%;
  list-style: none;
  padding-inline-start: 0;
}
.mainCon .left ul li{
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 18px 0;
  border-bottom: 1px solid rgba(250, 250, 250, 1) ;
  cursor: pointer;
  position: relative;
  flex-wrap: wrap;
}
.third{
  width:100%;
  display: none;
}
.third span{
  text-align: left;
  padding: 10px 0;
  font-size: 14px;
  transition: all 2s;
}
.third span:hover{
  color:#C9382C;
}
.mainCon .left ul li:hover .third{
  display: flex;
  flex-direction: column;
}
.mainCon .left ul li span{
  font-weight: bold;
  transition: all 2s;
  font-size: 14px;
}
.mainCon .left ul li:hover .aSpan{
  color:#C9382C;
}
.mainCon .left ul li:hover .icon-tianjia::before{
  color:#C9382C;
}
  .mainCon .right{
    width:80%;
    margin-left: 5%;
    display: flex;
    padding-left: 5%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    border-left: 1px solid rgba(250, 250, 250, 1);
  }
  .right .item{
    width:30%;
    border: 1px solid rgba(250, 250, 250, 1);
    padding: 10px 5px;
    border-radius: 2%;
    margin-top: 60px;
    cursor: pointer;
    height:350px;
  }
  a{
    text-decoration: none;
    color:black;
  }
  .item p{
    transition: all 2s;
  }
  .item img{
    transition: all 2s;
    margin-top: 30px;
  }
  .item:hover p{
    color:rgba(201, 56, 44, 1);
  }
  .item:hover img{
    transform: scale(1.05);
  }
  .aBtn{
    padding-bottom: 60px;
  }
@media screen and (max-width:450px){
  .banner{
    height:100vh;
    object-fit: cover;
  }
  .proCon{
    overflow: hidden;
  }
  .link .main,.mainCon{
    width:90%;
    margin-left: 5%;
  }
  .mainCon .left{
    width:50%;
  }
  .mainCon .right{
    width:50%;
    margin-left: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .right .item{
    width:100%;
    height:200px;
  }
  .right .item img{
    width:100%;
    object-fit: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pro.vue